import './TabsDropComponent.css'
/**
 * 小型可点击标签组件
 * - list: 数据源，包含 id 与 label
 * - num: 当前选中项 id
 * - tabsDropFun: 点击回调（item, id）
 * - backColor: 背景色
 */
export default function TabsDropComponent({ list, num, tabsDropFun, backColor, ...props }) {
  return (
    <div className="flexRow flexRowStart">
      {list.map(item => {
        return (
          <div
            onClick={e => tabsDropFun(item, item.id)}
            key={item.id}
            style={{ backgroundColor: backColor || '#ffffff' }}
            className={
              num === item.id
                ? 'tabs_head_small_car_cur tabs_head_small_car flexRow tabs_head_small_car_all'
                : 'tabs_head_small_car flexRow tabs_head_small_car_all'
            }
            {...props}
          >
            {item.label}
          </div>
        )
      })}
    </div>
  )
}
